export default () => ({
    isLoading: true,
    errorMessage: null,
    favorites: [],
    detail: {}
})